import { z } from 'zod';

export const ApprovalRequestSchema = z.object({
  id: z.string().min(1),
  chain_id: z.string(),
  step_order: z.number().int(),
  entity_type: z.string(),
  entity_id: z.string().min(1),
  status: z.string(),
  required_scope: z.string(),
  decided_by: z.string().nullable(),
  decided_at: z.string().nullable(),
  comment: z.string().nullable(),
  expires_at: z.string().nullable(),
  created_at: z.string(),
});

export type ApprovalRequest = z.infer<typeof ApprovalRequestSchema>;

export const ApprovalDecisionRequestSchema = z.object({
  comment: z.string().max(2000).nullable().optional(),
});

export type ApprovalDecisionRequest = z.infer<typeof ApprovalDecisionRequestSchema>;

export const ApprovalDecisionResponseSchema = z.object({
  updated_request: ApprovalRequestSchema,
  signal: z.enum(['CHAIN_COMPLETE', 'STEP_APPROVED', 'REJECTED', 'NONE']),
  next_requests: z.array(ApprovalRequestSchema),
});

export type ApprovalDecisionResponse = z.infer<typeof ApprovalDecisionResponseSchema>;

/** Payload delivered to the panel via registry / chat ui_action */
export const ApprovalContextPayloadSchema = z.object({
  approvalId: z.string().min(1),
});

export type ApprovalContextPayload = z.infer<typeof ApprovalContextPayloadSchema>;

/** Form-level schema — enforces non-blank comment for reject */
export const RejectFormSchema = z.object({
  comment: z.string().min(1, 'required').max(2000),
});

export const ApproveFormSchema = z.object({
  comment: z.string().max(2000).optional(),
});
